<app-image-form-field
  [image]="imageUrl ? { url: imageUrl, ref: null } : null"
  (imageChange)="image = $event; imageUrlChange.emit($event?.url)"
  [basePath]="'users/' + userId"
  [label]="label"
></app-image-form-field>
